export enum TNCAcceptanceMoment {
  ACCOUNT_ACTIVATION = 1,
  REPEAT_TIME_OPEN_APP = 2,
  EVERY_TIME_OPEN_APP = 3,
  MAKE_BOOKING = 4,
  START_BOOKING = 5,
  OPEN_BOOKING = 6,
  CTG_SELECTION = 7
}

export enum TNCAction {
  ACCEPTED = 1,
  REJECTED = 2,
  REVOKED = 3
}

export enum InvoiceStatusEnum {
  OPEN = 0,
  SENT = 1,
  CLOSED = 2,
  REQUESTFORPAYMENT = 3,
  REOPEN = 4
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/models/enum-helper.ts